import UtilsSchema from "@repoflow/schema/utils";

import FieldsSchema, {
  siteKey,
  orgId,
  siteId,
  packId,
  route,
  type,
  fileId,
  status,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...FieldsSchema,
  {
    id: "/Public/SitePack",
    type: "object",
    properties: {
      siteKey,
      orgId,
      siteId,
      packId,
      route,
      type,
      fileId,
      status,
      createdAt,
      updatedAt,
    },
  },
  {
    // Named, routed and given its directory rule — but no archive. Attaching
    // one is the edit screen's job, for the same reason a section's markup is:
    // the file has to exist before it can be picked, and a create dialog that
    // demands one cannot be completed by somebody who has not uploaded it yet.
    id: "/Public/SitePack/Create",
    type: "object",
    properties: {
      packId,
      route,
      type,
    },
    // Mirrors SitePackInputCreate's non-null fields exactly. An empty
    // `required` array is what left assertValid unable to reject anything in
    // the project this shape came from (A9 in docs/datum-api.md) — and gen-2's
    // own SitePackInputCreate had exactly that hole.
    required: ["packId", "route", "type"],
  },
  {
    // `fileId` is here and `packId` is not: the name is the key and cannot
    // move, everything else about a mount can. Gen-2 additionally refused to
    // let `type` change; see the note on that field for why this does not.
    id: "/Public/SitePack/Update",
    type: "object",
    properties: {
      route,
      type,
      fileId,
    },
    required: ["route"],
  },
];
